export const ZONES_MAP_NAME = 'zones-map';

const MAP_PATH = `${process.env.REACT_APP_API_ENDPOINT}/data/map`;

export const MAP_DEFAULT_ROTATION_RADIANS = 1.171;
export const MAP_DEFAULT_ROTATION_DEGREES = 67;
export const MAP_DEFAULT_VIEW = { center: [11576769.600619148, 150290.5916487966], zoom: 6.000598556824275 };

export const GEO_JSONS_INFO = [
  { name: 'aircraft stands', path: `${MAP_PATH}/ERA.json`, zoom: 4, color: '#DC681A' },
  { name: 'runways', path: `${MAP_PATH}/Runway Edge.json`, zoom: 3, color: '#D848C6' },
  { name: 'roadways', path: `${MAP_PATH}/Airside Roadway.json`, zoom: 4, color: '#9CD848' },
  { name: 'taxiways', path: `${MAP_PATH}/Taxiway Markings.json`, zoom: 4, color: '#486AD8' },
  { name: 'pushback-related', path: `${MAP_PATH}/EOT, EOP.json`, zoom: 4, color: '#D8AD48' },
  { name: 'pushback-related', path: `${MAP_PATH}/Stopbar.json`, zoom: 4, color: '#D8AD48' },
  { name: 'stand name', path: `${MAP_PATH}/Stand Name.json`, zoom: 6, color: '#D848C7', labelKey: 'Stand Name' },
];

export const ATOMS_LAYERS_GROUPS: Record<string, string[]> = {
  turf: ['airside turf fill'],
  buildings: [
    'airside building fill',
    'airside building name',
    'Building overlay base',
    'Building underlay icon',
    'Building overlay',
    'Building overlay outline',
    'Building icon',
  ],
  taxiway: [
    'airside line base',
    'taxiway line',
    'taxiway name',
    'pushback line',
    'pushback fill',
    'leadin line',
    'leadin fill',
    'acft type marking line',
    'acft type marking names',
    'Compass Swing line dashed',
    'Compass Swing line',
    'EOT EOP line',
    'EOT TOP Compass Swing names',
    'taxiway holding psn line',
  ],
  roadway: ['airside roadway edge'],
  runway: [
    'runway holding psn line',
    'runway fill',
    'runway displ threshold fill',
    'runway stopway fill',
    'runway stopway line',
    'runway clearway outline',
    'runway strip outline',
    'runway resa outline',
    'runway resa line',
    'runway name',
  ],
  aircraftStand: [
    'airside markings fill',
    'airside kcz abl line',
    'airside markings line',
    'stand marking fill',
    'stand marking names',
    'apron stand name',
  ],
  construction: ['airside construction fill', 'airside construction line', 'Airside Construction Name'],
  others: ['mws marking fill'],
  jetBlastFence: ['fence jet blast fill', 'fence jet blast name'],
  aerobridge: ['Aerobridge'],
  perimeterFence: ['fence perimeter line'],
};

export const ATOMS_LAYERS_GROUPS_IDS = [
  'turf',
  'buildings',
  'taxiway',
  'roadway',
  'runway',
  'aircraftStand',
  'construction',
  'jetBlastFence',
  'aerobridge',
  'perimeterFence',
  'others',
];

export const ATOMS_LAYERS_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'turf', label: 'Turf' },
  { value: 'buildings', label: 'Buildings' },
  { value: 'taxiway', label: 'Taxiway' },
  { value: 'roadway', label: 'Roadway' },
  { value: 'runway', label: 'Runway' },
  { value: 'aircraftStand', label: 'Aircraft Stand' },
  { value: 'construction', label: 'Construction' },
  { value: 'jetBlastFence', label: 'Jet Blast Fence' },
  { value: 'aerobridge', label: 'Aerobridge' },
  { value: 'perimeterFence', label: 'Perimeter Fence' },
  { value: 'others', label: 'Others' },
];
